import React from 'react'

export default function Integration() {
  return (
    <div className='dx-card responsive-paddings'>
    <h1>Integration</h1>
  </div>   )
}
